<template>
  <router-view />
</template>

<script>
import { useRouter } from "vue-router";
export default {
  /*
  Si el usuario se encuentra autenticad (tiene id y token en localStorage)
  entonces lo redirigimos a la página de Cotización Rápida para que no
  vuelva a iniciar sesión.
  */
  setup() {
    const router = useRouter();
    const { _token, _id } = localStorage;

    if (_token && _id) {
      router.push({
        name: "cotizacion-rapida",
      });
    }
  },
};
</script>

<style></style>
